import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const form = this.element;

    form.noValidate = true
    form.addEventListener('submit', event => {
      if (!form.checkValidity()) {
        event.preventDefault()
        event.stopPropagation()
      }

      form.classList.add('was-validated')
    }, false)
  }
  
  clear() {
    const kept = [...this.element.querySelectorAll('[data-form-keep]')]
      .map(el => ({ el, value: el.value }))
    this.element.classList.remove('was-validated')
    this.element.reset()
    kept.forEach(({ el, value }) => { el.value = value })
  }
}